import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-check-order-selector',
  standalone: false,
  templateUrl: './check-order-selector.component.html',
  styleUrls: ['./check-order-selector.component.scss'],
})
export class CheckOrderSelectorComponent {
  @Input({ required: true }) public label = '';
  @Input({ required: true }) public value = '';
  @Input() public tone: 'default' | 'success' = 'default';
}
